import React from 'react'
import FileUploader from "react-firebase-file-uploader";
import { withFirebase } from '../firebase'
import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import Modal from 'react-modal';
import modalStyle from '../styles/modal';

Modal.setAppElement('#root');
class LegislationItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            uid: this.props.item.uid,
            type: this.props.item.type,
            title: this.props.item.title,
            fileUrl: this.props.item.fileUrl,
            confirm: {
                isShow: false,
                title: '',
                message: ''
            }
        }
    }

    handleUploadStart = () => {
        console.log("upload start");
        this.setState({
            loading: true
        });
    }

    handleUploadError = (error) => {
        this.setState({
            loading: false
        });
        this.props.showErrorModal("Los sentimos, ocurrió un error al subir el archivo.");
    };

    handleUploadSuccess = filename => {
        this.setState({
            loading: false,
        });
        this.props.firebase.file('legislations', filename).getDownloadURL()
            .then(fileUrl => {
                this.props.handleUploadFile(fileUrl, this.state)
            });
    };

    showConfirmModal = () => {
        this.setState({
            confirm: {
                isShow: true,
                title: 'Eliminar',
                message: "Está seguro de eliminar este elemento."
            }
        });
    }

    closeConfirmModal = (confirmed) => {
        this.setState({
            confirm: {
                isShow: false,
                title: '',
                message: ''
            }
        });
        if (confirmed) {
            this.props.handleDelete(this.props.item);
        }
    }

    render() {
        const { loading, title, fileUrl, confirm } = this.state;

        let fileUrlText = fileUrl;
        if (fileUrl && fileUrl.length > 0) {
            let index = fileUrl.lastIndexOf("?");
            fileUrlText = fileUrl.substring(0, index);
            index = fileUrlText.lastIndexOf("/");
            fileUrlText = fileUrlText.substring(index, fileUrlText.length);
        }
        const filesRef = this.props.firebase.folder('legislations');
        const fileName = title;
        const textButtom = fileUrl ? 'Modificar Archivo' : 'Seleccionar Archivo';

        return (
            <tr>
                <td className=" align-middle">{title}</td>
                <td className="text-nowrap align-middle">
                    {(fileUrlText) ?
                        <a target="_blank" rel="noopener noreferrer" href={fileUrl} className="card-link text-primary">
                            <FontAwesomeIcon className="mr-2" icon={faExternalLinkAlt} />
                            <small>Descargar</small>
                        </a>
                        :
                        <div className="text-break align-middle text-secondary"><small>Sin archivo</small></div>
                    }
                </td>
                <td className="align-middle" >
                    <div className="nav justify-content-end">
                        {(!loading) ?
                            <div>
                                <label className="btn btn-dark btn-sm mb-0" data-toggle="tooltip" data-placement="bottom" title={textButtom} >
                                    <FontAwesomeIcon className="" icon={faCloudUploadAlt} />
                                    <FileUploader
                                        hidden
                                        accept="application/pdf"
                                        name="file"
                                        filename={fileName}
                                        storageRef={filesRef}
                                        onUploadStart={this.handleUploadStart}
                                        onUploadError={this.handleUploadError}
                                        onUploadSuccess={this.handleUploadSuccess}
                                    />
                                </label>
                                <button onClick={this.showConfirmModal} className="btn btn-sm btn-danger ml-2" data-toggle="tooltip" data-placement="bottom" title="Eliminar">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </button>
                                {/* <label onClick={this.showConfirmModal} className="btn btn-sm btn-danger ml-2" data-toggle="tooltip" data-placement="bottom" title="Eliminar">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </label> */}
                            </div>
                            :
                            <div>
                                <Loader
                                    type="ThreeDots"
                                    color="#263238"
                                    height={50}
                                    width={50}
                                    timeout={0} />
                            </div>
                        }
                    </div>
                </td>
                <Modal
                    isOpen={confirm.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={() => this.closeConfirmModal(false)}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">{confirm.title}</h5>
                        <p className="card-text text-break">{confirm.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={() => this.closeConfirmModal(false)} className="btn btn-sm btn-dark">No</button>
                            <button onClick={() => this.closeConfirmModal(true)} className="btn btn-sm btn-dark ml-2 pl-2 pr-2">Si</button>
                        </div>
                    </div>

                </Modal>
            </tr>
        );
    }

}
export default withFirebase(LegislationItem);